<template>
  <ValidationObserver>
    <b-row v-if="valid && ready">
      <b-col cols="12">
        <PageHeader
          :page="header"
          left-side-class="col-12 col-lg-8"
          right-side-class="col-12 col-lg-4 d-flex align-items-center justify-content-end"
        >
          <template #customActions>
            <ActionButton
              text="Regresar"
              i="fas fa-arrow-circle-left fa-fw"
              variant="outline-success"
              class="mr-1"
              @click="$router.push({ name: 'location-alternatives' })"
            />
          </template>
        </PageHeader>
      </b-col>

      <b-col cols="12">
        <Board :details="schoolBoardDetails" />
      </b-col>
      <b-col cols="12" class="mt-4">
        <SectionTitle
          has-line
          content="Configuración de Alternativa de Ubicación"
        />
      </b-col>
      <b-col cols="12">
        <AlternativeList
          :viewmodel="viewmodel"
          :alternatives.sync="model.alternatives"
          @on-create-action-plan="handleCreateActionPlan"
        />
      </b-col>
    </b-row>
  </ValidationObserver>
</template>
<script>
import PageHeader from 'PageHeader';
import alert from '@/mixin/alert.mixin';
import ActionButton from 'ActionButton';
import Board from 'Board';
import SectionTitle from 'SectionTitle';
import AlternativeList from './_components/AlternativeList';
import * as api from '@/views/pei/location-alternatives/_api';
import objectToFormData from 'object-to-formdata';

const initialViewmodelBuilder = (
  { academicYear, center, municipality, school, availableGrades } = {
    academicYear: null,
    center: null,
    municipality: null,
    school: null,
    availableGrades: [],
  }
) => ({
  academicYear,
  center,
  municipality,
  school,
  availableGrades,
});
const initialModelBuilder = (
  { alternatives } = {
    alternatives: [],
  }
) => ({
  alternatives,
});

export default {
  name: 'LocationAlternativesCreate',
  mixins: [alert],
  components: {
    ActionButton,
    Board,
    SectionTitle,
    AlternativeList,
    PageHeader,
  },
  props: {
    schoolId: { type: [Number, String], default: null },
    academicYearId: { type: [Number, String], required: true, default: 0 },
  },
  data: () => ({
    header: {
      icon: 'fas fa-user-tie',
      title: 'Catálogo de Alternativa de Ubicación',
      routes: ['Inicio', 'PEI', 'Catálogo de Alternativa de Ubicación'],
    },
    viewmodel: initialViewmodelBuilder(),
    model: initialModelBuilder(),
    valid: false,
    ready: false,
  }),
  computed: {
    schoolBoardDetails() {
      const { academicYear, center, municipality, school } = this.viewmodel;
      return [
        [
          {
            label: 'Año Académico:',
            data: academicYear?.name,
            icon: 'fas fa-calendar-edit',
          },
          {
            label: 'Centro:',
            data: center?.name,
            icon: 'fas fa-ballot-check',
          },
          {
            label: 'Municipio:',
            data: municipality?.name,
            icon: 'fas fa-ballot-check',
          },
          {
            label: 'Escuela:',
            data: school?.name,
            icon: 'fas fa-ballot-check',
          },
        ],
      ];
    },
  },
  methods: {
    async submit() {
      const formData = objectToFormData(
        {
          alternatives: this.model.alternatives,
        },
        { indices: true }
      );

      const response = await api.updateLocationAlternative(
        {
          schoolId: this.schoolId,
          academicYearId: this.academicYearId,
        },
        formData
      );
      if (response.status) {
        this.viewmodel = initialViewmodelBuilder(response.data);
        this.model = initialModelBuilder(response.data);
        this.ShowToast(
          '',
          'La alternativa de ubicación ha sido guardada exitosamente.',
          'success'
        );
      } else {
        const message =
          response.data.response.data.message ||
          'La alternativa de ubicación no fue guardada.';
        this.ShowToast('Error', message, 'error');
      }
    },
    handleCreateActionPlan(item) {
      const schoolAlternativeLocationId = item.id;
      if (!schoolAlternativeLocationId) return;

      this.$router.push({
        name: 'location-alternatives-action-plan',
        params: {
          schoolAlternativeLocationId,
          academicYearId: this.academicYearId,
        },
      });
    },
  },
  async created() {
    this.valid = this.schoolId && this.academicYearId;
    if (this.valid) {
      const data = await api.getLocationAlternative({
        schoolId: this.schoolId,
        academicYearId: this.academicYearId,
      });
      if (data) {
        this.viewmodel = initialViewmodelBuilder(data);
        this.model = initialModelBuilder(data);
        this.ready = true;
        return;
      }
    }
    this.$router.replace({ name: 'location-alternatives' });
  },
};
</script>
